const newRoute = window.location.href
  // old trends redirect
  .replace(/trends\/?#/, '#/trends')
  // old artifacts redirect
  .replace(/artifacts\/?#/, '#/artifacts')
  // old embeddables redirect
  .replace(/embeddables\/?#/, 'u/#/embeddables');

window.location.replace(newRoute === window.location.href ? window.location.origin : newRoute);
